import { IChartTooltipData, IPoint } from '@/creditflowresearch/domain/vo/Bond/IChartTooltipData';
import { INIT_TOOLTIP_DATA } from '@/creditflowresearch/application/Bonds/charts/constants';
import { roundUpValueToFraction } from '@framework/data-helpers/number/roundUpValueToFraction';

const calculatePercent = (total: number, amount: number) => (amount / (total / 100));

const allOthersItemsToTooltipData = (allOthersItems, totalAmount, color) => allOthersItems.map((item) => ({
  ...item,
  color,
  percentage: totalAmount && calculatePercent(totalAmount, item.y),
}));

export const getTooltipData = (points: IPoint[]): IChartTooltipData[] => points.flatMap(
  ({ x, y, color, total, series, point }) => {
    if (point.detailData && point.detailData.length) {
      return allOthersItemsToTooltipData(point.detailData, total, color);
    }

    return {
      x,
      y,
      color,
      name: series.name,
      dealCount: point.dealCount,
      dealSize: point.dealSize,
      percentage: point.percentage || 0,
    };
  });

const updateTooltipData = (accumulatedData, { x, y, dealCount, dealSize, percentage }) => ({
  ...accumulatedData,
  x,
  y: y + accumulatedData.y,
  dealCount: dealCount + accumulatedData.dealCount,
  dealSize: dealSize + accumulatedData.dealSize,
  percentage: percentage === null ? null : (percentage + accumulatedData.percentage),
});

export const getGroupList = (data: IChartTooltipData[], count: number = 15): IChartTooltipData[] => {
  if (data.length <= count) {
    return data;
  }

  const sortData = data.sort((a, b) => b.y - a.y);
  const otherData = sortData.splice(count);

  const allOthers: IChartTooltipData = otherData.reduce(updateTooltipData, INIT_TOOLTIP_DATA);

  return [...sortData, allOthers];
};

export const roundChartValue = (value: number): string => {
  try {
    if (value < 10 ** 8) {
      return `${ roundUpValueToFraction(value / (10 ** 6), 1).toFixed(1) }m`;
    }

    return `${ roundUpValueToFraction(value / (10 ** 9), 1).toFixed(1) }b`;
  } catch (error) {
    return `${ value }`;
  }
};
